<template>
  <div class="modalEditProfile">
    <div class="modalEditProfile -bg" @click="$emit('close')"></div>
    <div class="modalEditProfile-content">
      <UserProfileForm
        v-show="!showPasswordForm"
        @closeModal="$emit('close')"
        :togglePasswordForm="togglePasswordForm"
      />
      <UserPasswordForm
        v-show="showPasswordForm"
        @closeModal="$emit('close')"
        :togglePasswordForm="togglePasswordForm"
      />
    </div>
  </div>
</template>

<script>
import UserProfileForm from "./UserProfileForm";
import UserPasswordForm from "./UserPasswordForm";

export default {
  name: "UserProfileModalEdit",
  components: {
    UserProfileForm,
    UserPasswordForm
  },
  data() {
    return {
      isLoading: false,
      showPasswordForm: false
    };
  },
  methods: {
    togglePasswordForm() {
      this.showPasswordForm = !this.showPasswordForm;
    }
  }
};
</script>

<style lang="scss" scoped>
.modalEditProfile {
  display: block;
  position: fixed;
  z-index: 1001;
  padding: 10px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  .-bg {
    background: black;
    content: "";
    opacity: 0.5;
    pointer-events: all;
    z-index: -1;
    height: 100%;
  }
  /deep/ &-content {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: #fff;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    z-index: 1;
    @media (max-width: 767px) {
      width: 500px;
    }
    @media (max-width: 575px) {
      width: 475px;
    }
    @media (max-width: 475px) {
      width: 300px;
    }
    &__header {
      color: #232323;
      font-size: 1rem;
      margin-bottom: 50px;
    }
    &__subheader {
      margin-top: 60px;
      font-size: 18px;
    }
    .form-material {
      padding-top: 4px;
      input {
        font-family: $font-family-base;
        font-size: 15px;
      }
    }
  }
  /deep/ &-header {
    margin-bottom: 40px;
    h5 {
      font-size: 24px;
      line-height: 26px;
      margin-bottom: 10px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
    }
  }
  /deep/ &-buttons {
    margin-top: 40px;
    .btn {
      margin-left: 10px;
    }
  }
  /deep/ &-exit {
    float: right;
    padding: 0;
    height: 0;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
